import React from "react";
import EditRoleAssignment from "../EditRoleAssignment";
import useSelector from "../../../store/useSelector";
import { Routes } from "../../routing/Routing";

const SystemAccessRoleAssignmentForm: React.FC = 
  () => {
    const {
      userManagement: {
        bulkEditUserData: {
          isEditRoleAssignment
        }
      }
    } = useSelector(store => store);

    const pageTitle = isEditRoleAssignment ? "Edit access detail" : "Enter access detail";

    return (
      <EditRoleAssignment 
        title={pageTitle}
        redirectRoute={Routes.RequestSystemAccess}
        onInvalidSelectedUserRoute={Routes.RequestSystemAccess}/>
    )
  }
export default SystemAccessRoleAssignmentForm;